import React from 'react';
import {
  LANDING_PAGE_GUIDE_GETTING_STARTED_INTRO,
  LANDING_PAGE_GUIDE_GETTING_STARTED_STEPS,
  LANDING_PAGE_GUIDE_STEP_ROUTES,
  LANDING_PAGE_GUIDE_HELP,
  LANDING_PAGE_GUIDE_INTRO,
  LANDING_PAGE_GUIDE_KEY_FEATURES,
  LANDING_PAGE_GUIDE_KEY_FEATURE_ROUTES,
  LANDING_PAGE_GUIDE_NEXT_STEPS,
  LANDING_PAGE_GUIDE_NEXT_STEP_ROUTES,
  LANDING_PAGE_GUIDE_NEXT_STEPS_INTRO,
  LANDING_PAGE_GUIDE_TITLE,
  LANDING_PAGE_GUIDE_WHAT_IS_ITEMS,
  LANDING_PAGE_GUIDE_WHAT_IS_TEXT,
} from '../../constants';
import {
  BulletItem,
  BulletList,
  ContentGrid,
  FeatureBlock,
  FeatureTitle,
  HelpCard,
  HelpCardTitle,
  LandingNumberList,
  DocsContent,
  ParagraphText,
  TableOfContentsWrapper,
  SectionTitle,
  TabSectionsContainer,
} from '../../styles';
import { TableOfContents } from '../TableOfContents/TableOfContents';
import { OptionalNavLabel } from '../common/OptionalNavLabel';

interface LandingPageGuideTabContentProps {
  selectedTabId: string;
}

export function LandingPageGuideTabContent({
  selectedTabId,
}: LandingPageGuideTabContentProps) {
  return (
    <ContentGrid>
      <DocsContent>
        <TabSectionsContainer>
          <section>
            <SectionTitle variant="h4">{LANDING_PAGE_GUIDE_TITLE}</SectionTitle>
            <ParagraphText>{LANDING_PAGE_GUIDE_INTRO}</ParagraphText>
          </section>

          <section>
            <SectionTitle variant="h5">What is the DX Portal?</SectionTitle>
            <ParagraphText>{LANDING_PAGE_GUIDE_WHAT_IS_TEXT}</ParagraphText>
            <BulletList>
              {LANDING_PAGE_GUIDE_WHAT_IS_ITEMS.map(item => (
                <BulletItem key={item}>{item}</BulletItem>
              ))}
            </BulletList>
          </section>

          <section>
            <SectionTitle variant="h5">Getting Started</SectionTitle>
            <ParagraphText>
              {LANDING_PAGE_GUIDE_GETTING_STARTED_INTRO}
            </ParagraphText>
            <LandingNumberList>
              {LANDING_PAGE_GUIDE_GETTING_STARTED_STEPS.map(step => (
                <li key={`${step.highlightedText}-${step.textSuffix}`}>
                  {step.textPrefix}
                  <OptionalNavLabel
                    label={step.highlightedText}
                    route={LANDING_PAGE_GUIDE_STEP_ROUTES[step.highlightedText]}
                  />
                  {step.textSuffix}
                </li>
              ))}
            </LandingNumberList>
          </section>

          <section>
            <SectionTitle variant="h5">Key Features</SectionTitle>
            {LANDING_PAGE_GUIDE_KEY_FEATURES.map(feature => (
              <FeatureBlock key={feature.title}>
                <FeatureTitle>
                  <OptionalNavLabel
                    label={feature.title}
                    route={LANDING_PAGE_GUIDE_KEY_FEATURE_ROUTES[feature.title]}
                  />
                </FeatureTitle>
                <ParagraphText>{feature.description}</ParagraphText>
              </FeatureBlock>
            ))}
          </section>

          <section>
            <SectionTitle variant="h5">Next Steps</SectionTitle>
            <ParagraphText>{LANDING_PAGE_GUIDE_NEXT_STEPS_INTRO}</ParagraphText>
            <BulletList>
              {LANDING_PAGE_GUIDE_NEXT_STEPS.map(step => (
                <BulletItem key={`${step.highlightedText}-${step.textSuffix}`}>
                  {step.textPrefix}
                  <OptionalNavLabel
                    label={step.highlightedText}
                    route={LANDING_PAGE_GUIDE_NEXT_STEP_ROUTES[step.highlightedText]}
                  />
                  {step.textSuffix}
                </BulletItem>
              ))}
            </BulletList>
          </section>

          <section>
            <HelpCard>
              <HelpCardTitle variant="h5">
                {LANDING_PAGE_GUIDE_HELP.title}
              </HelpCardTitle>
              <ParagraphText>{LANDING_PAGE_GUIDE_HELP.text}</ParagraphText>
            </HelpCard>
          </section>
        </TabSectionsContainer>
      </DocsContent>

      <TableOfContentsWrapper>
        <TableOfContents selectedTabId={selectedTabId} />
      </TableOfContentsWrapper>
    </ContentGrid>
  );
}
